import * as React from 'react';

import AccessStatsItem from './AccessStatsItem';

var AccessStatsItemsList = function AccessStatsItemsList(_ref) {
    var commentCount = _ref.commentCount,
        commentStatButtonProps = _ref.commentStatButtonProps,
        downloadCount = _ref.downloadCount,
        downloadStatButtonProps = _ref.downloadStatButtonProps,
        editCount = _ref.editCount,
        editStatButtonProps = _ref.editStatButtonProps,
        _ref$hasCountOverflow = _ref.hasCountOverflowed,
        hasCountOverflowed = _ref$hasCountOverflow === undefined ? false : _ref$hasCountOverflow,
        isBoxNote = _ref.isBoxNote,
        openAccessStatsModal = _ref.openAccessStatsModal,
        previewCount = _ref.previewCount,
        previewStatButtonProps = _ref.previewStatButtonProps,
        viewStatButtonProps = _ref.viewStatButtonProps;
    return React.createElement(
        'ul',
        { className: 'access-stats-list' },
        React.createElement(AccessStatsItem, {
            count: previewCount,
            hasCountOverflowed: hasCountOverflowed,
            openAccessStatsModal: openAccessStatsModal,
            statButtonProps: isBoxNote ? viewStatButtonProps : previewStatButtonProps,
            type: isBoxNote ? 'view' : 'preview'
        }),
        React.createElement(AccessStatsItem, {
            count: editCount,
            hasCountOverflowed: hasCountOverflowed,
            openAccessStatsModal: openAccessStatsModal,
            statButtonProps: editStatButtonProps,
            type: 'edit'
        }),
        React.createElement(AccessStatsItem, {
            count: commentCount,
            hasCountOverflowed: hasCountOverflowed,
            openAccessStatsModal: openAccessStatsModal,
            statButtonProps: commentStatButtonProps,
            type: 'comment'
        }),
        !isBoxNote && React.createElement(AccessStatsItem, {
            count: downloadCount,
            hasCountOverflowed: hasCountOverflowed,
            openAccessStatsModal: openAccessStatsModal,
            statButtonProps: downloadStatButtonProps,
            type: 'download'
        })
    );
};

AccessStatsItemsList.propTypes = {
    commentCount: PropTypes.number.isRequired,
    commentStatButtonProps: PropTypes.object.isRequired,
    downloadCount: PropTypes.number.isRequired,
    downloadStatButtonProps: PropTypes.object.isRequired,
    editCount: PropTypes.number.isRequired,
    editStatButtonProps: PropTypes.object.isRequired,
    hasCountOverflowed: PropTypes.bool.isRequired,
    isBoxNote: PropTypes.bool.isRequired,
    openAccessStatsModal: PropTypes.func,
    previewCount: PropTypes.number.isRequired,
    previewStatButtonProps: PropTypes.object.isRequired,
    viewStatButtonProps: PropTypes.object.isRequired
};
export default AccessStatsItemsList;
import PropTypes from 'prop-types';